document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="A1Testimonials-"]');

  sections.forEach((section) => {
    const topRow = section.querySelector('.a1-testimonials__row--top .a1-testimonials__track');
    const bottomRow = section.querySelector('.a1-testimonials__row--bottom .a1-testimonials__track');

    // Optional pause on hover for a more premium feel
    section.querySelectorAll('.a1-testimonials__row').forEach((row) => {
      row.addEventListener('mouseenter', () => {
        const track = row.querySelector('.a1-testimonials__track');
        if (track) track.style.animationPlayState = 'paused';
      });

      row.addEventListener('mouseleave', () => {
        const track = row.querySelector('.a1-testimonials__track');
        if (track) track.style.animationPlayState = 'running';
      });
    });

    // Pull speeds from CSS variables later if you want to wire them dynamically.
    if (topRow) topRow.style.animationDuration = '34s';
    if (bottomRow) bottomRow.style.animationDuration = '38s';
  });
});